/*
 * File: AsanaLogin.tsx
 * Project: a-a
 * File Created: Sunday, 8th June 2025 1:24:45 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 26th August 2025 7:39:58 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import zeplinColor from '../../../../theme/Color';
import { Link } from 'react-router-dom';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';

const AsanaLogin = () => {
  const asanaConnecting = sessionStorage.getItem('asana-connecting') === 'true';
  const [error, setError] = useState(false);
  const handleClose = () => {
    setError(false);
  };
  // console.log('error', error, localStorage.getItem('asana-fail'));
  // useEffect(() => {
  //   // const failAuth = sessionStorage.getItem('asana-fail');
  //   const failAuth = localStorage.getItem('asana-fail') || '';
  //   setError(failAuth && failAuth === 'true' ? true : false);

  // }, []);
  React.useEffect(() => {
    const handleCustomTokenValidate = (e: CustomEvent) => {
      console.log('Custom storage change detected:', e.detail);
      if (e.detail.key === 'asanaValidateToken') {
        setError(e.detail.value);
      }
    };

    // Add event listener
    window.addEventListener('asanaValidateToken', handleCustomTokenValidate as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('asanaValidateToken', handleCustomTokenValidate as EventListener);
    };
  }, []);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        zIndex: 100, // Ensure it appears above the blurred content
      }}
    >
      <img src={`/assets/asana-logo.svg`} width='48px' height='48px' />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant='heading3'>Connect Asana to Get Started</Typography>
        <Typography variant='body3' sx={{ textAlign: 'center' }} color={zeplinColor.Neutral10}>
          To view and manage your Asana projects and tasks directly within
          <br /> Huddle, please connect your Asana account.
        </Typography>
      </Box>
      {process.env.REACT_APP_ASANA_LOGIN && (
        <Link
          to={process.env.REACT_APP_ASANA_LOGIN}
          style={{ textDecoration: 'none' }}
          onClick={(e) => {
            asanaConnecting && e.preventDefault();
            asanaConnecting && e.stopPropagation();
          }}
        >
          <CustomButton
            disabled={false}
            onClick={() => {
              sessionStorage.setItem('asana-connecting', 'true');
              // sessionStorage.setItem('asana-auth', 'true');
            }}
            variant='contained'
            color={'primary'}
            style={{
              // width: '95px',
              borderRadius: '14px',
              height: 48,
              padding: '14px 16px',
              ...(asanaConnecting && { backgroundColor: zeplinColor.Neutral3 }),
              '&.Mui-focusVisible': {
                backgroundColor: asanaConnecting ? zeplinColor.Neutral3 : '#333CAA',
              },
            }}
            textStyle={{ color: asanaConnecting ? zeplinColor.BasicBlack : zeplinColor.Neutral1 }}
            text={asanaConnecting ? 'Connecting....' : 'Connect'}
            // icon={<img src={`/assets/add-white.svg`} width={'13.3px'} height={'13.3px'} />}
            // tabindex={4}
          />
        </Link>
      )}
      {error && (
        <Typography variant='responsiveBody3' color={zeplinColor.Error}>
          Something went wrong. Try logging in using different account.
        </Typography>
      )}
      {/* <CustomAlert
        open={error ? true : false}
        handleClose={handleClose}
        message={
          error ? (
            <CustomAlertContain
              alert={error && 'Something went wrong'}
              alertIcon={error && <img src='/assets/error.svg' width={24} height={24} />}
              error={error ? true : false}
            />
          ) : (
            ''
          )
        }
        error={error ? true : false}
      /> */}
    </Box>
  );
};

export default AsanaLogin;
